import dynamic from "next/dynamic";

export { chakraComponents } from "./chakra-components";
export type { DropdownIndicatorProps } from "./chakra-components";

/**
 * chakra-react-select v6 calls useChakraContext during render. Loading it
 * client-only avoids SSR ContextError when ChakraProvider is a client boundary.
 */
const Select = dynamic(
  () => import("./select-client").then((mod) => mod.Select),
  { ssr: false }
);

const AsyncSelect = dynamic(
  () => import("./select-client").then((mod) => mod.AsyncSelect),
  { ssr: false }
);

export { Select, AsyncSelect };
